import React, {FC, useCallback, useMemo, useState} from 'react';
import {DropSubscribeModalData, DropsSubscriptionSchema} from '../types';
import {
  DROPS_SUBSCRIPTION_STORAGE,
  DropsSubscriptionsContext,
} from './SubscriptionsProvider';

export const DropSubscriptionsProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const dropsSubscriptions = useDropsSubscriptions();

  return (
    <DropsSubscriptionsContext.Provider value={dropsSubscriptions}>
      {children}
    </DropsSubscriptionsContext.Provider>
  );
};

const useDropsSubscriptions = () => {
  const [userData, setUserData] = useState<DropsSubscriptionSchema>({
    guest: DROPS_SUBSCRIPTION_STORAGE.guest,
    ayUser: DROPS_SUBSCRIPTION_STORAGE.ayUser,
  });

  const [modalData, setModalData] = useState<DropSubscribeModalData>(
    DROPS_SUBSCRIPTION_STORAGE.modalData,
  );

  const setSubscriptionsCallback = useCallback(
    (subscriptions: DropsSubscriptionSchema) => {
      setUserData({
        ...userData,
        ...subscriptions,
      });
      // this method is necessary to update local storage whenever the subscriptions change
      DROPS_SUBSCRIPTION_STORAGE.setSubscriptions({
        ...userData,
        ...subscriptions,
      });
    },
    [userData],
  );

  const setModalDataCallback = useCallback(
    (data: any) => {
      setModalData({
        ...modalData,
        ...data,
      });
    },
    [modalData],
  );

  const updateIndividualDropsCallback = useCallback(
    (data: any) => {
      const updatedIndividualDrops = {
        ...userData,
      };

      if (data.ayUser) {
        updatedIndividualDrops.ayUser!.individualDrops = {
          ...updatedIndividualDrops.ayUser!.individualDrops,
          ...data.ayUser,
        };
      }

      if (data.guest) {
        updatedIndividualDrops.guest!.individualDrops = {
          ...updatedIndividualDrops.guest!.individualDrops,
          ...data.guest,
        };
      }

      setUserData(updatedIndividualDrops);
      DROPS_SUBSCRIPTION_STORAGE.setSubscriptions(updatedIndividualDrops);
    },
    [userData],
  );

  return useMemo(
    () => ({
      ...userData,
      modalData,
      setSubscriptions: setSubscriptionsCallback,
      setModalData: setModalDataCallback,
      updateIndividualDrops: updateIndividualDropsCallback,
    }),
    [
      userData,
      modalData,
      setSubscriptionsCallback,
      setModalDataCallback,
      updateIndividualDropsCallback,
    ],
  );
};
